import { Card, CardContent, Grid, TextField } from "@material-ui/core";
import { ClusterCreate_clusterCreate_errors } from "@saleor/cluster/types/ClusterCreate";
import CardTitle from "@saleor/components/CardTitle";
import FormSpacer from "@saleor/components/FormSpacer";
import { FormChange } from "@saleor/hooks/useForm";
import { commonMessages } from "@saleor/intl";
import { getFormErrors } from "@saleor/utils/errors";
import getClusterErrorMessage from "@saleor/utils/errors/cluster";
import React from "react";
import { useIntl } from "react-intl";

import { ClusterFormData } from "../ClusterCreatePage";

export interface ClusterContentProps {
  data: ClusterFormData;
  disabled: boolean;
  errors: ClusterCreate_clusterCreate_errors[];
  onChange: FormChange;
  localError: {
    lowerPrepTimeDays: string;
    lowerPrepTimeHours: string;
    lowerPrepTimeMins: string;
    upperPrepTimeDays: string;
    upperPrepTimeHours: string;
    upperPrepTimeMins: string;
  };
}

const ClusterContent: React.FC<ClusterContentProps> = props => {
  const { data, disabled, onChange, errors, localError } = props;
  const intl = useIntl();

  const formErrors = getFormErrors(
    [
      "lowerPrepTimeDays",
      "lowerPrepTimeHours",
      "lowerPrepTimeMins",
      "upperPrepTimeDays",
      "upperPrepTimeHours",
      "upperPrepTimeMins"
    ],
    errors || []
  );

  return (
    <Card>
      <CardTitle title={intl.formatMessage(commonMessages.clusterDetails)} />
      <CardContent>
        <h4>Lower Limit</h4>
        <FormSpacer />
        <Grid container spacing={4}>
          <Grid item xs={4}>
            <TextField
              id="lowerLimitDaysTxt"
              disabled={disabled}
              error={
                !!formErrors.lowerPrepTimeDays || !!localError.lowerPrepTimeDays
              }
              label={intl.formatMessage({
                defaultMessage: "Days"
              })}
              value={data.lowerPrepTimeDays}
              helperText={
                !!localError.lowerPrepTimeDays
                  ? localError.lowerPrepTimeDays
                  : getClusterErrorMessage(formErrors.lowerPrepTimeDays, intl)
              }
              name="lowerPrepTimeDays"
              onChange={event => {
                if (/^[0-9]*$/.test(event.target.value)) {
                  onChange(event);
                }
              }}
              fullWidth
              inputProps={{
                min: 1
              }}
            />
          </Grid>
          <Grid item xs={4} /* className={classes.formGrid}*/>
            <TextField
              id="lowerLimitHoursTxt"
              disabled={disabled}
              error={
                !!formErrors.lowerPrepTimeHours ||
                !!localError.lowerPrepTimeHours
              }
              label={intl.formatMessage({
                defaultMessage: "Hours"
              })}
              value={data.lowerPrepTimeHours}
              helperText={
                !!localError.lowerPrepTimeHours
                  ? localError.lowerPrepTimeHours
                  : getClusterErrorMessage(formErrors.lowerPrepTimeHours, intl)
              }
              name="lowerPrepTimeHours"
              onChange={event => {
                if (/^[0-9]*$/.test(event.target.value)) {
                  onChange(event);
                }
              }}
              fullWidth
              inputProps={{
                min: 1
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              id="lowerLimitMinsTxt"
              disabled={disabled}
              error={
                !!formErrors.lowerPrepTimeMins || !!localError.lowerPrepTimeMins
              }
              label={intl.formatMessage({
                defaultMessage: "Mins"
              })}
              value={data.lowerPrepTimeMins}
              helperText={
                !!localError.lowerPrepTimeMins
                  ? localError.lowerPrepTimeMins
                  : getClusterErrorMessage(formErrors.lowerPrepTimeMins, intl)
              }
              name="lowerPrepTimeMins"
              onChange={event => {
                if (/^[0-9]*$/.test(event.target.value)) {
                  onChange(event);
                }
              }}
              fullWidth
              inputProps={{
                min: 1
              }}
            />
          </Grid>
        </Grid>

        <h4>Upper Limit</h4>
        <FormSpacer />
        <Grid container spacing={4}>
          <Grid item xs={4}>
            <TextField
              id="upperLimitDaysTxt"
              disabled={disabled}
              error={
                !!formErrors.upperPrepTimeDays || !!localError.upperPrepTimeDays
              }
              label={intl.formatMessage({
                defaultMessage: "Days"
              })}
              value={data.upperPrepTimeDays}
              helperText={
                !!localError.upperPrepTimeDays
                  ? localError.upperPrepTimeDays
                  : getClusterErrorMessage(formErrors.upperPrepTimeDays, intl)
              }
              name="upperPrepTimeDays"
              onChange={event => {
                if (/^[0-9]*$/.test(event.target.value)) {
                  onChange(event);
                }
              }}
              fullWidth
              inputProps={{
                min: 1
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              id="upperLimitHoursTxt"
              disabled={disabled}
              error={
                !!formErrors.upperPrepTimeHours ||
                !!localError.upperPrepTimeHours
              }
              label={intl.formatMessage({
                defaultMessage: "Hours"
              })}
              value={data.upperPrepTimeHours}
              helperText={
                !!localError.upperPrepTimeHours
                  ? localError.upperPrepTimeHours
                  : getClusterErrorMessage(formErrors.upperPrepTimeHours, intl)
              }
              name="upperPrepTimeHours"
              onChange={event => {
                if (/^[0-9]*$/.test(event.target.value)) {
                  onChange(event);
                }
              }}
              fullWidth
              inputProps={{
                min: 1
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              id="upperLimitMinsTxt"
              disabled={disabled}
              error={
                !!formErrors.upperPrepTimeMins || !!localError.upperPrepTimeMins
              }
              label={intl.formatMessage({
                defaultMessage: "Mins"
              })}
              value={data.upperPrepTimeMins}
              helperText={
                !!localError.upperPrepTimeMins
                  ? localError.upperPrepTimeMins
                  : getClusterErrorMessage(formErrors.upperPrepTimeMins, intl)
              }
              name="upperPrepTimeMins"
              onChange={event => {
                if (/^[0-9]*$/.test(event.target.value)) {
                  onChange(event);
                }
              }}
              fullWidth
              inputProps={{
                min: 1
              }}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ClusterContent;
